import React from 'react';
import { inject, observer } from 'mobx-react';
import styles from './index.module.scss';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import Avatar from '@components/avatar';
import { BASE_IMG_URL } from '@images/imageUrls';
import { withRouter } from 'react-router-dom';
import { BaseComponent } from '@components/Base/h5/BaseComponent';
import type { BaseRouteComponentProps } from '../../../types/base';
import InfiniteScrollList from '@components/InfiniteScrollList';
import { highlightname } from '@utils/high-light-name';

interface H5ThreadListProps extends BaseRouteComponentProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    data: any;
    loading?: boolean;
    hasMore?: boolean;
    onLoadMore?: () => void;
    goUser?: Function
    userList?: any // 推荐关注用户列表
    createFollowUser?: any  // 关注用户事件
    followDelete?: any  // 取消关注用户事件
    searchKeyword?: any // 高亮字段
    emptyText?: string; // 为空时提示文字
    emptyIcon?: string; // 为空时icon
    emptyBoxStyle?: any; // 为空状态时的自定义样式
}

@inject('app', 'site', 'user')
@observer
class H5ThreadList extends BaseComponent<H5ThreadListProps> {
    componentDidMount() {
        // 可以在这里添加初始化逻辑
        console.log('这里是H5');
    }

    
    

    // 渲染单个列表项
    renderUserItem = (item: any, index: number) => {
        const { goUser, searchKeyword, createFollowUser, followDelete } = this.props;
        return (
            <React.Fragment key={item.id || item._id || index}>
                <div className={styles.userItem}>
                    <Avatar
                        avatarUrl={item.avatar}
                        titleMark={item.titleMark}
                        userCode={item.code}
                        size={72}
                        officialSize={24}
                    ></Avatar>
                    <div className={styles.userInfo}>
                    <div 
                        className={styles.username}
                        dangerouslySetInnerHTML={{ 
                            __html: highlightname(item.nickname, searchKeyword) || '用户名'
                        }}
                        />
                        {item.titleName && (
                            <div className={styles.titleName}>
                                {item.titleName}
                            </div>
                        )}
                    </div>
                    {!item.isFollow && <div className={styles.threadUserFollow} onClick={(e) => {
                        e.stopPropagation();
                        window.globalEnsureLogin(() => {
                            createFollowUser && createFollowUser(item, index)
                        });
                    }}>关注</div>}
                    {item.isFollow && <div className={styles.threadUserFollowed} onClick={(e) => {
                        e.stopPropagation();
                        window.globalEnsureLogin(() => { 
                            followDelete && followDelete(item, index)
                        });
                        
                    }}>已关注</div>}
                    {/* {item.isFollow && <div className={styles.threadUserFollowed} onClick={(e) => {
                        e.stopPropagation();
                        window.globalEnsureLogin(() => { 
                            createFollowUser && createFollowUser(item, index)
                        });
                        
                    }}>互相关注</div>} */}
                </div>
                
            </React.Fragment>
        );
    };

    renderContent() {
        const { userList, loading = false, hasMore = true, emptyText, emptyIcon, emptyBoxStyle, onLoadMore } = this.props;

        if (!Array.isArray(userList)) return null;

        return (
            <div className={styles.listBox} style={{background: userList?.length == 0 ? 'transparent' : ''}}>
                <InfiniteScrollList
                    variant="h5"
                    data={userList}
                    loading={loading}
                    hasMore={hasMore}
                    onLoadMore={onLoadMore || (() => { })}
                    renderItem={(item, index) => this.renderUserItem(item, index)}
                    threshold={100}
                    emptyText={emptyText || '这里是空的'}
                    emptyIcon={emptyIcon}
                    emptyBoxStyle={emptyBoxStyle}
                    loadingText="加载中..."
                    noMoreText="没有更多了"
                />
            </div>
        );
    }
}

export default withRouter(H5ThreadList);